import * as React from 'react'

import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { translations as legalAndExtrasTranslations } from 'modules/contracts/components/FixFlow/lib/legalAndExtrasTranslations'
import { ContractFlowType } from 'modules/contracts/components/FlowPage'

import CustomFieldsSection from '../_CustomFields'

interface Props {
  form: Form
  translations?: { [key: string]: string }
  step?: number
  type?: ContractFlowType
  withFormWrapper?: boolean
}

const CustomFields = ({
  form,
  step,
  type = 'fix',
  withFormWrapper,
  translations = legalAndExtrasTranslations(),
}: Props) => {
  return (
    <CustomFieldsSection
      withFormWrapper={withFormWrapper}
      form={form}
      translations={translations}
      step={step}
      type={type}
    />
  )
}

export default observer(CustomFields)
